import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sharedAccessApi } from '../api';
import { trackEventMixpanel } from '../../utils';

interface UseAcceptShareAccessParams {
  userId: string;
  referralCode: string;
}

export const useAcceptShareAccess = () => {
  const queryClient = useQueryClient();
  const acceptShareAccessMutation = useMutation({
    mutationFn: ({ userId, referralCode }: UseAcceptShareAccessParams) => {
      return sharedAccessApi.acceptSharedAccess(userId, {
        referralCode,
      });
    },
    onSuccess: (_, { referralCode }) => {
      trackEventMixpanel('accept_friend', { referralCode });
      queryClient.invalidateQueries({ queryKey: ['lifestack.friendsList'] });
    },
  });

  return {
    acceptShareAccess: acceptShareAccessMutation.mutateAsync,
    ...acceptShareAccessMutation,
  };
};
